import { useTranslation } from 'react-i18next'

function TermsAndConditionsPage() {
  const { t: translate } = useTranslation()

  return <div>{translate('terms_and_conditions_page')}</div>
}

export default TermsAndConditionsPage
